<app-table-card-layout
    #cardLayout
    title="Moratorium Activity"
    [isLoading]="isLoaded()"
    [failed]="failed()"
    [hasData]="allMoratoriums().length > 0"
    [noDataMessage]="globalMessages.noDataAvailabelMsg"
    [errorMessage]="globalMessages.serviceMsgError"
    (retry)="reloadMoratoriums()"
>
    @if(moratoriums().length > 0){
    <div class="d-flex flex-column psic-gap-6">
        @if (!cardLayout.isCompact()) {
        <!-- Standard table view -->
        <div class="table-container" [class.table-container--collapsed]="!showAll() && allMoratoriums().length > 6">
            <table class="moratorium-table">
                <thead>
                    <tr class="disclaimer-bold">
                        <th style="width: 12%">Action Date</th>
                        <th style="width: 10%">Zip Code</th>
                        <th style="width: 12%">Action Type</th>
                        <th style="width: 15%">Moratorium Type</th>
                        <th style="width: 20%">Moratorium Name</th>
                        <th style="width: 12%">Start Date</th>
                        <th style="width: 12%">End Date</th>
                        <th style="width: 7%">LOB</th>
                        <th style="width: 10%">User ID</th>
                    </tr>
                </thead>
                <tbody>
                    @for (moratorium of moratoriums(); track moratorium.zipCode + moratorium.startDate + moratorium.lob; let i = $index) {
                    <tr [class.active]="selectedRow === i" (click)="selectRow(i)">
                        <td class="disclaimer">{{ moratorium.formattedUpdatedAt }}</td>
                        <td class="disclaimer">{{ moratorium.zipCode }}</td>
                        <td class="disclaimer">{{ moratorium.action }}</td>
                        <td class="disclaimer">{{ moratorium.moratoriumType }}</td>
                        <td class="disclaimer moratorium-name">{{ moratorium.moratoriumName }}</td>
                        <td class="disclaimer">{{ moratorium.formattedStartDate }}</td>
                        <td class="disclaimer">{{ moratorium.formattedEndDate }}</td>
                        <td class="disclaimer">{{ moratorium.lob }}</td>
                        <td class="disclaimer">{{ moratorium.updatedBy }}</td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="9" class="text-center disclaimer">No moratorium activity available.</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        } @else {
        <!-- Compact 2-column key-value view -->
        <div
            class="compact-list d-flex flex-column psic-gap-6"
            [class.compact-list--collapsed]="!showAll() && allMoratoriums().length > 6"
        >
            @for (moratorium of moratoriums(); track moratorium.zipCode + moratorium.startDate + moratorium.lob; let i = $index) {
            <div
                class="compact-card"
                [class.active]="selectedRow === i"
                (click)="selectRow(i)"
            >
                <table class="compact-table">
                    <tbody class="d-flex flex-column psic-gap-3 psic-py-3">
                        <tr>
                            <td class="compact-label disclaimer-bold">Action Date</td>
                            <td class="compact-value disclaimer">{{ moratorium.formattedUpdatedAt }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Zip Code</td>
                            <td class="compact-value disclaimer">{{ moratorium.zipCode }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Action Type</td>
                            <td class="compact-value disclaimer">{{ moratorium.action }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Moratorium Type</td>
                            <td class="compact-value disclaimer">{{ moratorium.moratoriumType }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Moratorium Name</td>
                            <td class="compact-value disclaimer">{{ moratorium.moratoriumName }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Start Date</td>
                            <td class="compact-value disclaimer">{{ moratorium.formattedStartDate }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">End Date</td>
                            <td class="compact-value disclaimer">{{ moratorium.formattedEndDate }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">LOB</td>
                            <td class="compact-value disclaimer">{{ moratorium.lob }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">User ID</td>
                            <td class="compact-value disclaimer">{{ moratorium.updatedBy }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            } @empty {
            <div class="text-center disclaimer psic-py-4">No moratorium activity available.</div>
            }
        </div>
        }

        <div class="d-flex flex-row justify-content-center align-items-center psic-pb-3 w-100">
            @if (!showAll() && allMoratoriums().length > 6) {
            <lib-button
                (click)="loadMore()"
                [disabled]="false"
                [buttonType]="'borderless'"
                [buttonSize]="'medium'"
                [buttonText]="'Show more'"
                [libIcon]="'chevron-down'"
            ></lib-button>
            } @else if (showAll() && allMoratoriums().length > 6) {
            <lib-button
                (click)="showLess()"
                [disabled]="false"
                [buttonType]="'borderless'"
                [buttonSize]="'medium'"
                [buttonText]="'Show less'"
                [libIcon]="'chevron-up'"
            ></lib-button>
            }
        </div>
    </div>
    }
</app-table-card-layout>